/**
 * Numeric keyboard layout factory.
 */

/**
 * Compute only the row that changes based on isDot/typed.
 * Called in a separate useMemo([isDot, typed]) so the rest of layouts
 * don't rebuild on every keystroke.
 */
export function computeDotRow(isDot, typed) {
  return isDot && !typed?.includes('.')
    ? ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp} {done}']
    : ['1 2 3', '4 5 6', '7 8 9', '0 {bksp} {done}'];
}

/**
 * Build all numeric layouts.
 * @param {object} opts
 * @param {boolean} opts.isClr           — numeric: show {bin}/00 vs {bksp}
 * @param {boolean} opts.zipcodeFlag     — number: show {bksp} {done} vs {bin} {bksp}
 * @param {boolean} opts.isOfflinePay
 * @param {boolean} opts.callApi
 * @param {string}  opts.screenType
 * @param {Array}   opts.dotRow          — pre-computed dot row (from computeDotRow)
 */
export function buildNumericLayouts({ isClr, zipcodeFlag, isOfflinePay, callApi, screenType, dotRow }) {
  return {
    numericAlpha: [
      '1 2 3',
      '4 5 6',
      '7 8 9',
      `{default} 0 ${(callApi || isOfflinePay) ? '{bksp}' : '{done}'}`,
    ],

    numericDefault: zipcodeFlag
      ? ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {done}']
      : ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 {bksp}'],

    numericDefaultWithDone: ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 {bksp}'],

    numericDot: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 .'],

    numericWithDotClear: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0 .'],

    numericDefaultWithDot: dotRow,

    numericShift: ['! / #', '$ % ^', '& * (', '{shift} ) +', '{bksp}'],

    numericSwipe: ['1 2 3', '4 5 6', '7 8 9', '{swipe} 0 {bksp}'],

    numeric: isClr
      ? ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 00']
      : ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 '],

    numericDefaultWithoutDone: ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp}'],

    numericWithBin:
      screenType === 'AddSeats' || screenType === 'cashOutLandScape' || screenType === 'cashOutPotrait'
        ? ['1 2 3', '4 5 6', '7 8 9', '{emptySpace} 0 {bksp}']
        : ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 {bksp}'],

    numericAlphaWithoutDone: ['1 2 3', '4 5 6', '7 8 9', '{default} 0 {bksp}'],

    numericWithdone: ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 {done}'],
  };
}
